import { j as e } from "../jsx-runtime-DywqP_6a.js";
import * as o from "@radix-ui/react-tooltip";
import * as d from "react";
import { c as i } from "../cn-dYga0KKN.js";
const p = o.Provider, f = o.Root, c = o.Trigger, g = (t) => /* @__PURE__ */ e.jsx(
  o.Arrow,
  {
    ...t,
    className: i(t.className, "fill-border")
  }
), m = d.forwardRef(({ className: t, sideOffset: a = 4, ...r }, s) => /* @__PURE__ */ e.jsx(
  o.Content,
  {
    ref: s,
    sideOffset: a,
    className: i(
      "z-50 overflow-hidden rounded-md border bg-popover px-3 py-1.5 text-sm text-popover-foreground shadow-md animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      t
    ),
    ...r
  }
));
m.displayName = o.Content.displayName;
export {
  f as Tooltip,
  g as TooltipArrow,
  m as TooltipContent,
  p as TooltipProvider,
  c as TooltipTrigger
};
//# sourceMappingURL=Tooltip.js.map
